/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AppSecOpsVulnerabilityByRegionWidgetConfiguration extends models.BaseChartWidgetConfigurationModel {
    constructor() {
        super();
        this.setDiscriminator("AppSecOpsVulnerabilityByRegionWidgetConfiguration");
    }

    getFixupPrototypeFunction() { return AppSecOpsVulnerabilityByRegionWidgetConfiguration.fixupPrototype; }

    static newInstance(model: Partial<AppSecOpsVulnerabilityByRegionWidgetConfiguration>): AppSecOpsVulnerabilityByRegionWidgetConfiguration {
        let obj = Object.assign(new AppSecOpsVulnerabilityByRegionWidgetConfiguration(), model);
        AppSecOpsVulnerabilityByRegionWidgetConfiguration.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AppSecOpsVulnerabilityByRegionWidgetConfiguration>): AppSecOpsVulnerabilityByRegionWidgetConfiguration {
        if (!model) return null;
        return AppSecOpsVulnerabilityByRegionWidgetConfiguration.newInstance(<AppSecOpsVulnerabilityByRegionWidgetConfiguration> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AppSecOpsVulnerabilityByRegionWidgetConfiguration) {
        if (!obj) return;

        models.AppSecOpsVulnerabilityByRegionWidgetConfiguration.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AppSecOpsVulnerabilityByRegionWidgetConfiguration): boolean {
        if (models.BaseChartWidgetConfigurationModel.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, AppSecOpsVulnerabilityByRegionWidgetConfiguration.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
